import { api } from "../api";
export const balanceApi = api.injectEndpoints({
    endpoints: (build) => ({
        getBalance: build.query({
            query: (args) => {
                return {
                    url: `program-service/api/v1/widget/user/balance`,
                    headers: {
                        'X-Loyalty-Language': (args.locale).split('-')[0],
                        'Authorization': `Bearer ${args.jwt}`,
                    }
                };
            },
            forceRefetch: () => true
        }),
        unsubscribe: build.mutation({
            query: (args) => ({
                url: 'program-service/api/v1/user/unsubscribe',
                headers: {
                    'X-Loyalty-Language': (args.locale).split('-')[0],
                    'Authorization': `Bearer ${args.jwt}`,
                },
                method: 'POST'
            }),
        }),
        reactivate: build.mutation({
            query: (args) => ({
                url: 'program-service/api/v1/user/reactivation',
                headers: {
                    'X-Loyalty-Language': (args.locale).split('-')[0],
                    'Authorization': `Bearer ${args.jwt}`,
                },
                method: 'POST'
            }),
        }),
    })
});
//# sourceMappingURL=balance.api.js.map